import { TextField } from "@fluentui/react";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import ICurrentUser from "../../entities/helper/ICurrentUser";
import { shortDate } from "../../helpers/dateHelper";
import { deleteAPI, getAPI, getAPIBlob, postAPI } from "../../helpers/httpHelper";
import { usePromiseEffect } from "../../helpers/promiseEffect";
import { cognitoUserInfo, cognitoUserToken } from "../../helpers/userHelper";
import { API_PROVEEDOR_GET_PLANIFICACIONES, URL_PROVIDER } from "../../helpers/variableHelper";
import UserPicker from "../../controls/UserPicker";
import IUserPickerValue from "../../entities/helper/IUserPickerValue";
import Swal, { SweetAlertResult } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import IMedidas from "../../entities/IMedidas";
import IPlanificacion from "../../entities/IPlanificacion";
import { E_EstadoFormPrograma, E_EstadoMedida, E_EstadoPlanificacion } from "../../enums/E_EstadoProveedor";
import Loading from "../../cross/Loading";

interface IMedidasProps {
  id_evaluacion: number;
  planificacion?: IPlanificacion;
  estadoTest?: number;
  viewMedidasTest?: boolean;
  medidaTest?: IMedidas;
  medidasTest?: any;
  is_Test?: boolean;
}

const MySwal = withReactContent(Swal);
const Medidas = ({ id_evaluacion, planificacion, estadoTest, viewMedidasTest, medidaTest, medidasTest, is_Test }: IMedidasProps) => {// NOSONAR "Se aplica en esta linea ya que SONAR nos arroja 291 como valor de complejidad cognitiva. El componente de medidas utiliza una gran cantidad de lógica dada sus etapas"
  const userInfo = cognitoUserToken();
  const [tokenState, setTokenState] = useState("");
  const [clickedRow, setClickedRow] = useState<number>(0);
  const [clickedRows, setClickedRows] = useState<Array<number>>([]);
  const [currentUser, setCurrentUser] = useState<ICurrentUser>();
  const [listItems, setListItems] = useState<Array<IMedidas>>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingDocuments, setIsLoadingDocuments] = useState(false);
  const [fechaHasta, setFechaHasta] = useState<string>(shortDate(new Date()) ?? "");
  const [valResponsable, setValResponsable] = useState<IUserPickerValue | null>();
  const [rechazados, setRechazados] = useState<boolean>(false);
  const [loadedFromAPI, setLoaded] = useState<boolean>(false);
  const [estado, setEstadoPrograma] = useState<E_EstadoFormPrograma>(estadoTest || E_EstadoFormPrograma.Lectura);
  const [arrErrorEmpty, setArrErrorEmpty] = useState<Array<string>>([]);
  const [descripcion, setDescripcion] = useState("");
  const [rejected, setRejected] = useState(false);
  usePromiseEffect(async () => {
    let token = await userInfo;
    setTokenState(token);
    let currUser = await cognitoUserInfo();
    console.log("currUser", currUser);
    setCurrentUser(currUser);
    await getAllMedidas(token, currUser);

    if (planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    }
    if (planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas) {
      setEstadoPrograma(E_EstadoFormPrograma.Lectura);
    }

    const date = new Date();
    let dateString = date.toISOString().split("T")[0];
    setFechaHasta(dateString);
    setValResponsable({ name: planificacion?.PROVEEDOR_RESPONSABLE_DISPLAY ?? "", mail: planificacion?.PROVEEDOR_RESPONSABLE ?? "" });
    setIsLoading(false);
  }, []);

  const getAllMedidas = async (token: string, currUser: ICurrentUser | undefined) => {
    let resultMedida = is_Test
      ? medidasTest
      : (
          await getAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/getmedidas/${id_evaluacion}/${planificacion?.ID_ESTADO}`, {
            Authorization: `Bearer ${token}`,
          })
        ).result;

    let re = resultMedida.data
      .filter((p: any) => p.ESTADO_MEDIDA !== "rechazado")
      .some((p: any) => p.RECHAZO !== undefined && p.RECHAZO !== "" && p.RECHAZO !== null);
    setRechazados(re);

    if (resultMedida.data.some((d: any) => d.ID_ESTADO === 1) && planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas) {
      let itemsAprobados = resultMedida.data.filter((d: any) => d.ID_ESTADO === 1);
      setRejected(itemsAprobados.some((a: any) => a.RECHAZO !== ""));
      setListItems(itemsAprobados);
    } else if (
      resultMedida.data.some((d: any) => d.ID_ESTADO === 5) &&
      planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados
    ) {
      setListItems(resultMedida.data.filter((d: any) => d.ID_ESTADO === 5));
    } else if (planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada) {
      setListItems(resultMedida.data.filter((d: any) => d.ID_ESTADO === E_EstadoMedida.EvidenciaEnviada));
    } else {
      setListItems(resultMedida.data);
    }

    if (resultMedida.data.length > 0) {
      setLoaded(resultMedida.data.length > 0);
    } else if (planificacion?.PROVEEDOR_RESPONSABLE === currUser?.email) {
      setEstadoPrograma(E_EstadoFormPrograma.Agregar);
    }
  };

  const formValidation = (value: Partial<IMedidas>) => {
    let arrErrors: Array<string> = [];
    let arrErrorsText: Array<string> = [];
    if (value.MEDIDA === "") {
      arrErrors.push("MEDIDA");
      arrErrorsText.push("Debe agregar una observación");
    } else if (value.RESPONSABLE === "") {
      arrErrors.push("RESPONSABLE");
      arrErrorsText.push("Debe asignar un responsable");
    } else if (value.FECHA_COMPROMISO === "") {
      arrErrors.push("FECHA_COMPROMISO");
      arrErrorsText.push("Debe seleccionar una fecha de compromiso");
    }

    if (arrErrorsText.length > 0) {
      MySwal.fire({
        html: (
          <div>
            <h3>Debe considerar lo siguiente:</h3>
            {arrErrorsText.map((e) => (
              <p key={e}>{e}</p>
            ))}
          </div>
        ),
        text: "",
        icon: "error",
        showCloseButton: true,
      });
    }

    setArrErrorEmpty(arrErrors);
    return arrErrors.length === 0;
  };

  const eliminar = (row: IMedidas) => {
    MySwal.fire({
      text: `¿Está seguro que desea eliminar la medida?`,
      icon: "question",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      showCloseButton: true,
      showCancelButton: true,
    }).then(async (result: SweetAlertResult) => {
      if (result.isConfirmed) {
        const medidas = [...listItems];
        let index = medidas.findIndex((d) => d.ID === row.ID);
        medidas.splice(index, 1);
        setListItems(medidas);
      }
    });
  };

  const grabarMedidas = async (l_medida?: Array<IMedidas>, saveFromRejected?: boolean, rechazar?: boolean, cerrar: boolean = false) => {
    setIsLoading(true);
    let medidas = l_medida !== undefined ? l_medida : listItems;

    let count: number = 0;
    medidas.forEach((medida) => {
      let medidaEditada = medida;
      medidaEditada.ID = loadedFromAPI ? medidaEditada.ID : undefined;
      medidaEditada.ID_EVALUACION = id_evaluacion;
      medidaEditada.ID_ESTADO = saveFromRejected ? 1 : medidaEditada.ID_ESTADO;
      count++;
    });
    try {
      await postAPI(
        `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/postmedida`,
        medidas,
        { Authorization: `Bearer ${tokenState}` },
        { ID: planificacion?.ID, last: medidas.length === count }
      );
    } catch (e: any) {
      if (e.response.status === 409) {
        MySwal.fire({
          text: "Debe ingresar evidencias en todas las medidas",
          icon: "question",
          confirmButtonText: "Aceptar",
          showCloseButton: true,
          showCancelButton: false,
        }).then(async (result: SweetAlertResult) => {
          let medidas1 = listItems;
          medidas1.forEach((m) => {
            if (clickedRows.includes(m.ID || 0)) {
              m.ID_ESTADO = 2;
              m.ID_EVALUACION = id_evaluacion;
            }
          });
          setListItems([...medidas1]);
        });
        setIsLoading(false);
        return;
      }
    }

    if (cerrar) {
      window.location.href = "/proveedores/home";
      return;
    }
    let firstCreation = medidas.filter((d) => d.ID === undefined);

    if (firstCreation.length > 0) {
      if (planificacion) {
        planificacion.ID_ESTADO = 4;
      }

      setIsLoading(false);
    } else if (!saveFromRejected) {
      let plan = planificacion;
      if (plan !== undefined) {
        plan.ID_ESTADO = 8;
        if (!rechazar) {
          plan.ID_ESTADO = 5;
        }
      }
    }
    window.location.href = "/proveedores/home";
  };

  const saveMedida = () => {
    const medidas = is_Test ? medidasTest.data : [...listItems];
    let medida: IMedidas = {
      ID: medidas.length + 1,
      FECHA_COMPROMISO: fechaHasta || "",
      MEDIDA: descripcion || "",
      RESPONSABLE: valResponsable?.mail || "",
      RESPONSABLE_DISPLAY: valResponsable?.name || "",
      AUTOR: planificacion?.PROVEEDOR_RESPONSABLE as string,
      AUTOR_DISPLAY: planificacion?.PROVEEDOR_RESPONSABLE_DISPLAY as string,
      ID_ESTADO: 1,
      NUEVO: true,
      OPEN: false,
      DOCUMENTOS: [],
    };
    if (is_Test || formValidation(medida)) {
      medidas.push(medida);
      setListItems(medidas);

      setValResponsable({ name: planificacion?.PROVEEDOR_RESPONSABLE_DISPLAY ?? "", mail: planificacion?.PROVEEDOR_RESPONSABLE ?? "" });
      setDescripcion("");
    }
  };

  const aprobarMedidas = (rechazar: boolean, test?: boolean) => {
    let medidas = test ? (medidasTest.data as IMedidas[]) : listItems;
    if (!rechazar) {
      let empty = listItems.filter((d) => clickedRows.includes(d.ID || 0) && d.RECHAZO === null);
      if (empty.length > 0) {
        MySwal.fire({
          text: `Debe agregar un motivo de rechazo para rechazar las medidas`,
          icon: "question",
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showCloseButton: true,
          showCancelButton: false,
        }).then(async (result: SweetAlertResult) => {});
        return;
      }
      medidas.forEach((m) => {
        if (clickedRows.includes(m.ID || 0)) {
          m.ID_ESTADO = 5;
          m.ID_EVALUACION = id_evaluacion;
        }
      });

      medidas = medidas.filter((d) => d.ID_ESTADO === 5);
    } else {
      medidas.forEach((m) => {
        if (clickedRows.includes(m.ID || 0)) {
          m.ID_ESTADO = 2;
          m.ID_EVALUACION = id_evaluacion;
          m.RECHAZO = "";
        }
      });

      medidas = medidas.filter((d) => d.ID_ESTADO === 2);
    }

    grabarMedidas(medidas);
  };

  const enviarMedidas = () => {
    if (clickedRows.length === 0 || is_Test) {
      MySwal.fire({
        text: `Debe seleccionar una medida para enviar`,
        icon: "question",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showCloseButton: true,
        showCancelButton: false,
      });
    } else if (listItems.some((d) => clickedRows.includes(d.ID ?? 0) && (d.RESPONSABLE === currentUser?.email || d.AUTOR === currentUser?.email))) {
      let medidas = listItems;
      medidas.forEach((m) => {
        if (clickedRows.includes(m.ID || 0)) {
          m.ID_ESTADO = 3;
          m.ID_EVALUACION = id_evaluacion;
        }
      });
      grabarMedidas(medidas);
    }
  };

  const cerrarMedidas = () => {
    let rows = is_Test ? [1, 2, 3] : clickedRows;
    if (rows.length === 0) {
      MySwal.fire({
        text: `Debe seleccionar una medida para cerrarla`,
        icon: "question",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        showCloseButton: true,
        showCancelButton: false,
      }).then(async (result: SweetAlertResult) => {
        if (result.isConfirmed) {
          console.log("");
        }
      });
    } else {
      let medidas = listItems;
      let medida1: IMedidas[] = [];
      medidas.forEach((m) => {
        if (rows.includes(m.ID || 0)) {
          m.ID_ESTADO = 4;
          m.ID_EVALUACION = id_evaluacion;
          medida1.push(m);
        }
      });
      grabarMedidas(medida1, false, false, true);
    }
  };

  const handleUploadDocument = async (id: number, file: any) => {
    let f = (file.files as FileList)[0] as any;
    const formData = new FormData();
    formData.append("ID_MEDIDA", id.toString());
    formData.append("DESCRIPCION", "");
    formData.append("FILE", f);
    console.log("FILE", f);
    setIsLoadingDocuments(true);

    await postAPI(`${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/PostDocumentoMedidaEvidencia`, formData, {
      Authorization: `Bearer ${tokenState}`,
    });
    await getAllMedidas(tokenState, currentUser);
    setIsLoadingDocuments(false);
  };

  const getContenidoArchivo = async (ruta: string) => {
    setIsLoadingDocuments(true);
    getAPIBlob(
      `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/GetContenidoDocumentoMedida`,
      { Authorization: `Bearer ${tokenState}` },
      {
        RUTA: ruta,
      }
    ).then((r) => {
      let file = r.result;
      let fileURL = URL.createObjectURL(file);
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.download = ruta.split("/")?.pop() || ruta;
      fileLink.click();
      setIsLoadingDocuments(false);
    });
  };

  const eliminarDocumento = (value: number, url: string) => {
    MySwal.fire({
      text: `¿Está seguro que desea eliminar la evidencia?`,
      icon: "question",
      confirmButtonText: "Aceptar",
      cancelButtonText: "Cancelar",
      showCloseButton: true,
      showCancelButton: true,
    }).then(async (result: SweetAlertResult) => {
      if (result.isConfirmed) {
        setIsLoadingDocuments(true);
        try {
          let result = await deleteAPI(
            `${URL_PROVIDER}${API_PROVEEDOR_GET_PLANIFICACIONES}/DeleteDocumentoMedida`,
            {
              Authorization: `Bearer ${tokenState}`,
            },
            { ID: value, URL: url }
          );
          await getAllMedidas(tokenState, currentUser);
          setIsLoadingDocuments(false);
          return result.result.data.data;
        } catch (error: any) {
          console.error(error);
          setIsLoadingDocuments(false);
          return -1;
        }
      }
    });
  };

  const isEvaluator = (evaluators?: string, currUser?: ICurrentUser) => {
    if (evaluators !== undefined && evaluators !== null) {
      let arrayEvaluadores = evaluators.split("; ");
      const isEvaluator = arrayEvaluadores.some((evaluator) => evaluator.trim() === currUser?.email);
      return isEvaluator;
    }
    return false;
  };

  return isLoading ? (
    <div>
      <Loading />
    </div>
  ) : (
    <div className="row">
      <button
        hidden={true}
        data-testid="btnformvalidation"
        onClick={() => {
          if (medidaTest) {
            formValidation({ MEDIDA: "a", RESPONSABLE: "" });
            formValidation({ MEDIDA: "", RESPONSABLE: "" });
            formValidation({ MEDIDA: "a", RESPONSABLE: "s", FECHA_COMPROMISO: "" });
          }
          eliminarDocumento(1, "");
        }}></button>
      <button
        hidden={true}
        data-testid="btnaprobar"
        onClick={() => {
          aprobarMedidas(false, true);
        }}></button>
      <button
        hidden={true}
        data-testid="btnrechazar"
        onClick={() => {
          aprobarMedidas(true, true);
          enviarMedidas();
        }}></button>
      <button
        hidden={true}
        data-testid="btngrabar"
        onClick={() => {
          grabarMedidas(medidasTest.data, false, false, false);
          saveMedida();
        }}></button>
      <button
        hidden={true}
        data-testid="btncerrar"
        onClick={() => {
          cerrarMedidas();
        }}></button>
      <button
        hidden={true}
        data-testid="btnupload"
        onClick={() => {
          handleUploadDocument(1, { files: [] as FileList[] });
          getContenidoArchivo("");
        }}></button>
      <button
        hidden={true}
        data-testid="btneliminar"
        onClick={() => {
          if (medidaTest) eliminar(medidaTest);
        }}></button>
      <button
        hidden={true}
        data-testid="btnisevaluator"
        onClick={() => {
          isEvaluator(planificacion?.EVALUADORES, currentUser);
        }}></button>
      <div className="col-12">
        <div className="rounded bg-white p-2 shadow">
          <div className="container-fluid mb-4">
            <h1 className="titPrincipal colorTit">Medidas</h1>
            <div className="card bg-light border p-3 pt-2 mt-2">
              <div className="col-12">
                <h6>
                  <span className="textSeccion">{planificacion?.CORRELATIVO}</span>
                </h6>
              </div>
              {estado === E_EstadoFormPrograma.Agregar ? (
                <div className="row ajusteInput mb-3">
                  <div className="col-12">
                    <h6>
                      <span className="textSeccion"></span>
                    </h6>
                  </div>

                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>Plan de acción </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    <TextField
                      multiline
                      onChange={(e: any) => {
                        setDescripcion(e.currentTarget.value);
                      }}
                      value={descripcion}
                      maxLength={1000}></TextField>
                    <span>{descripcion.length}/1000</span>{" "}
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>Fecha compromiso </label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-8 mb-1">
                    <input
                      type="date"
                      defaultValue={fechaHasta}
                      onChange={(e) => {
                        setFechaHasta(e.target.value);
                      }}
                      className={`${arrErrorEmpty.includes("FECHA_COMPROMISO") && "error"} form-control form-control-sm w-50 me-2`}
                    />
                    <label></label>
                  </div>
                  <div className="col-sm-12 col-md-6 col-lg-4 mb-1">
                    <label>Responsable </label>
                  </div>
                  <div className={`col-sm-6 col-md-6 col-lg-6 mb-1 ${arrErrorEmpty.includes("RESPONSABLE") && "error"}`}>
                    <UserPicker
                      className="borderColorGris"
                      name={"detectadoPor"}
                      callback={(id, value) => {
                        setValResponsable(value?.shift() || null);
                      }}
                      id={"detectadoPor"}
                      key={"1"}
                      multi={false}
                      disabled={planificacion?.TIPO_PROVEEDOR.toUpperCase() === "EXTERNO"}
                      defaultValue={valResponsable}
                    />
                  </div>

                  <div className="col-sm-4 col-md-4 col-lg-4 mt-3">
                    <button type="button" arial-label="Agregar" className="btn btn-sm btn-primary me-2" onClick={saveMedida}>
                      {" "}
                      <i className="bi bi-search me-2"></i>Agregar
                    </button>
                  </div>
                </div>
              ) : (
                <></>
              )}
              <div
                hidden={
                  planificacion?.ID_ESTADO === E_EstadoPlanificacion.EnConstruccion ||
                  planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ||
                  planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                  planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados
                }
                className="alert alert-warning p-1 mb-2"
                role="alert">
                <i className="text-info bi bi-info-circle-fill me-2"></i>
                <small>
                  <strong>Importante:</strong> Seleccione las medidas haciendo clic en el campo de selección
                </small>
              </div>
              <table className="table table-hover tablaTLC table-sm">
                <thead>
                  <tr>
                    <th></th>
                    <th hidden={(planificacion?.ID_ESTADO || 0) < 4 || planificacion?.ID_ESTADO == E_EstadoPlanificacion.EvaluacionCerrada}>
                      <input
                        type="checkbox"
                        hidden={
                          planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                          planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ||
                          (planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas &&
                            planificacion.EVALUADOR_LIDER !== currentUser?.email &&
                            !isEvaluator(planificacion?.EVALUADORES, currentUser)) ||
                          (planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados &&
                            planificacion.EVALUADOR_LIDER !== currentUser?.email &&
                            !isEvaluator(planificacion?.EVALUADORES, currentUser) &&
                            listItems.some((d) => d.ID_ESTADO !== 1)) ||
                          (planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor &&
                            planificacion.EVALUADOR_LIDER !== currentUser?.email &&
                            !isEvaluator(planificacion?.EVALUADORES, currentUser)) ||
                          (planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas &&
                            planificacion.PROVEEDOR_RESPONSABLE !== currentUser?.email) ||
                          (planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada &&
                            planificacion?.EVALUADOR_LIDER !== currentUser?.email &&
                            !isEvaluator(planificacion?.EVALUADORES, currentUser))
                        }
                        onChange={(e) => {
                          let rows: number[] = clickedRows;
                          if (e.currentTarget.checked) {
                            let ids = [];
                            if (planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada) {
                              ids = listItems.filter((d) => d.ID_ESTADO === E_EstadoMedida.EvidenciaEnviada).map((d) => d.ID);
                            } else {
                              ids = listItems
                                .filter((d) => d.ID_ESTADO !== E_EstadoMedida.Rechazado && d.ID_ESTADO !== E_EstadoMedida.EvidenciaEnviada)
                                .map((d) => d.ID);
                            }
                            if (ids !== undefined) {
                              ids.forEach((d) => {
                                rows.push(d || 0);
                              });
                            }
                          } else {
                            rows = [];
                          }
                          setClickedRows([...rows]);
                        }}
                      />
                    </th>
                    <th>Medida</th>
                    <th>Responsable</th>
                    <th>Fecha de compromiso</th>
                    <th hidden={planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados}>Estado</th>
                    <th>Motivo del rechazo</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {listItems.map((p: IMedidas, index: number) => {
                    return (
                      <>
                        <tr className="fondoTRmedidas">
                          <td>
                            <i
                              className={`arrow ${!p.OPEN ? "down" : "right"}`}
                              hidden={
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados
                              }
                              onClick={() => {
                                if ((planificacion?.ID_ESTADO || 0) < 4) {
                                  return;
                                }
                                if (p.ID !== undefined) {
                                  let medidas = listItems;
                                  medidas.forEach((medida) => {
                                    if (medida.ID === p.ID && p.OPEN) {
                                      medida.OPEN = false;
                                    } else if (medida.ID === p.ID) {
                                      medida.OPEN = true;
                                    }
                                  });
                                  setListItems([...medidas]);
                                }
                              }}
                            />
                          </td>
                          <td
                            hidden={
                              (planificacion?.ID_ESTADO || 0) < 4 ||
                              planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                              planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ||
                              (planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas && p.ID_ESTADO === 5)
                            }>
                            <input
                              type="checkbox"
                              hidden={
                                ((planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
                                  planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas) &&
                                  planificacion?.EVALUADOR_LIDER !== currentUser?.email &&
                                  !isEvaluator(planificacion?.EVALUADORES, currentUser)) ||
                                (planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas &&
                                  p.RESPONSABLE !== currentUser?.email &&
                                  planificacion?.PROVEEDOR_RESPONSABLE !== currentUser?.email) ||
                                (planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas &&
                                  p.ID_ESTADO === E_EstadoMedida.EvidenciaEnviada &&
                                  (p.RESPONSABLE === currentUser?.email || planificacion?.PROVEEDOR_RESPONSABLE === currentUser?.email)) ||
                                (planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada &&
                                  planificacion?.EVALUADOR_LIDER !== currentUser?.email &&
                                  !isEvaluator(planificacion?.EVALUADORES, currentUser))
                              }
                              checked={clickedRows.includes(p.ID || 0)}
                              onChange={(e) => {
                                let rows = clickedRows;
                                if (e.currentTarget.checked) {
                                  rows.push(p?.ID || 0);
                                } else {
                                  let index = rows.findIndex((r) => r === p?.ID);

                                  rows.splice(index, 1);
                                }
                                setClickedRows([...rows]);
                              }}
                            />
                          </td>
                          <td width="25%">
                            {(p.ID_ESTADO === E_EstadoMedida.Rechazado || p.ID_ESTADO === E_EstadoMedida.NoAprobada) &&
                            planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados &&
                            planificacion.PROVEEDOR_RESPONSABLE === currentUser?.email ? (
                              <TextField
                                value={p.MEDIDA}
                                multiline
                                onChange={(e) => {
                                  let medidas = listItems;
                                  medidas.forEach((m) => {
                                    if (m.ID === p.ID) {
                                      m.MEDIDA = e.currentTarget.value;
                                    }
                                  });
                                  setListItems([...medidas]);
                                }}
                              />
                            ) : (
                              <label>{p.MEDIDA}</label>
                            )}
                          </td>
                          <td width="25%">
                            {p.ID_ESTADO === E_EstadoMedida.Rechazado &&
                            planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados &&
                            planificacion.PROVEEDOR_RESPONSABLE === currentUser?.email ? (
                              <UserPicker
                                name={"detectadoPor"}
                                callback={(id, value) => {
                                  let medidas = listItems;
                                  medidas.forEach((m) => {
                                    if (m.ID === p.ID) {
                                      let user = value?.shift() || null;
                                      m.RESPONSABLE = user?.mail || "";
                                      m.RESPONSABLE_DISPLAY = user?.name || "";
                                    }
                                  });

                                  setListItems([...medidas]);
                                }}
                                id={"detectadoPor"}
                                key={"1"}
                                multi={false}
                                disabled={false}
                                defaultValue={{ mail: p.RESPONSABLE, name: p.RESPONSABLE_DISPLAY }}
                              />
                            ) : (
                              <label>{p.RESPONSABLE_DISPLAY}</label>
                            )}
                          </td>
                          <td width="15%">
                            {p.ID_ESTADO === 1 && planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ? (
                              <Form.Control
                                defaultValue={p.FECHA_COMPROMISO}
                                onChange={(e) => {
                                  let medidas = listItems;
                                  medidas.forEach((m) => {
                                    if (m.ID === p.ID) {
                                      m.FECHA_COMPROMISO = e.currentTarget.value;
                                    }
                                  });
                                  setListItems(medidas);
                                }}
                                className={`${arrErrorEmpty.includes("FECHA_COMPROMISO") && "error"}`}
                                type="date"
                              />
                            ) : (
                              <label>{shortDate(p.FECHA_COMPROMISO)}</label>
                            )}
                          </td>
                          <td width="15%" hidden={planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados}>
                            <label>{p.ESTADO_MEDIDA}</label>
                          </td>
                          <td width="35%">
                            {(planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
                              planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor) &&
                            (planificacion?.EVALUADOR_LIDER === currentUser?.email || isEvaluator(planificacion?.EVALUADORES, currentUser)) ? (
                              <TextField
                                multiline
                                disabled={rechazados && planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas}
                                onChange={(e) => {
                                  let medidas = listItems;
                                  medidas.forEach((m) => {
                                    if (m.ID === p.ID) {
                                      m.RECHAZO = e.currentTarget.value;
                                    }
                                  });

                                  setListItems(medidas);
                                }}
                              />
                            ) : (
                              <label>{p.ID_ESTADO === E_EstadoMedida.Rechazado ? p.RECHAZO : ""}</label>
                            )}
                          </td>
                          <td
                            hidden={
                              planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                              planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
                              planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
                              (planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados &&
                                planificacion?.PROVEEDOR_RESPONSABLE !== currentUser?.email) ||
                              (planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor &&
                                p.ID_ESTADO !== E_EstadoMedida.Rechazado) ||
                              (planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas && p.ID_ESTADO !== E_EstadoMedida.Rechazado)
                            }>
                            <i
                              className="bi bi-trash iconSearch"
                              onClick={() => {
                                eliminar(p);
                              }}
                            />
                          </td>
                          <td>
                            <button
                              hidden={
                                p.ID_ESTADO === E_EstadoMedida.EvidenciaEnviada ||
                                p.ID_ESTADO === E_EstadoMedida.Cerrada ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.PlanInformado ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
                                (p.RESPONSABLE !== currentUser?.email &&
                                  p.DOCUMENTOS !== undefined &&
                                  p.DOCUMENTOS.length > 0 &&
                                  planificacion?.PROVEEDOR_RESPONSABLE !== currentUser?.email) ||
                                (p.RESPONSABLE !== currentUser?.email &&
                                  planificacion?.PROVEEDOR_RESPONSABLE !== currentUser?.email &&
                                  planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas) ||
                                isLoadingDocuments
                              }
                              className="btn btn-sm btn-light border py-0 px-1"
                              title="Adjuntar"
                              onClick={() => {
                                setClickedRow(p.ID ?? 0);
                                document.getElementById("inputGroupFile" + p.ID)?.click();
                              }}>
                              <i className="bi bi-paperclip"></i>
                            </button>
                          </td>
                        </tr>
                        {isLoadingDocuments && clickedRow === p.ID ? (
                          <tr>
                            <td align="center" colSpan={12}>
                              <Loading />
                            </td>
                          </tr>
                        ) : (
                          <>
                            <tr hidden={!p.OPEN}>
                              <td colSpan={p.ID_ESTADO === E_EstadoMedida.Cerrada ? 6 : 12}>
                                <input
                                  type="file"
                                  className="form-control form-control-sm"
                                  hidden={true}
                                  id={"inputGroupFile" + p.ID}
                                  aria-describedby="inputGroupFileAddon04"
                                  aria-label="Seleccionar Archivos"
                                  onChange={(e) => handleUploadDocument(clickedRow, e.currentTarget)}
                                />
                              </td>
                            </tr>
                            <tr hidden={!p.OPEN}>
                              <td align="center" colSpan={12} className="px-4">
                                {p.DOCUMENTOS !== undefined && p.DOCUMENTOS.length > 0 ? (
                                  <table className="table table-hover tablaTLC">
                                    <thead>
                                      <th>Evidencia</th>
                                      <th>Ver</th>
                                      <th hidden={p.ID_ESTADO === 3}>Eliminar</th>
                                    </thead>
                                    <tbody>
                                      {p.DOCUMENTOS.map((d) => {
                                        return (
                                          <tr key={d.ID}>
                                            <td width={"80%"}>{d.URL.split("/").pop()}</td>
                                            <td align="center" width={"10%"}>
                                              <i
                                                className="bi bi-search iconSearch"
                                                onClick={() => {
                                                  setClickedRow(p.ID ?? 0);
                                                  getContenidoArchivo(d.URL);
                                                }}
                                              />
                                            </td>
                                            <td
                                              align="center"
                                              width={"10%"}
                                              hidden={
                                                p.ID_ESTADO === 3 ||
                                                planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                                                (p.RESPONSABLE !== currentUser?.email && planificacion?.PROVEEDOR_RESPONSABLE !== currentUser?.email)
                                              }>
                                              <i
                                                className="bi bi-trash iconTrash"
                                                onClick={() => {
                                                  setClickedRow(p.ID ?? 0);
                                                  eliminarDocumento(d.ID, d.URL);
                                                }}></i>
                                            </td>
                                          </tr>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                ) : (
                                  <span>No se encontraron evidencias para esta medida</span>
                                )}
                              </td>
                            </tr>
                          </>
                        )}
                      </>
                    );
                  })}
                </tbody>
              </table>
              <div className="col-sm-4 col-md-4 col-lg-4 mt-3">
                {planificacion?.PROVEEDOR_RESPONSABLE === currentUser?.email && (
                  <button
                    hidden={
                      planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas ||
                      planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasEnviadasProveedor ||
                      planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
                      planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
                      planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
                      planificacion?.ID_ESTADO == E_EstadoPlanificacion.EvaluacionCerrada
                    }
                    type="button"
                    className="btn btn-sm btn-primary me-2"
                    disabled={listItems.length === 0}
                    onClick={() => grabarMedidas()}>
                    {" "}
                    <i className="bi me-2"></i>{" "}
                    {planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados &&
                    planificacion?.PROVEEDOR_RESPONSABLE !== currentUser?.email
                      ? "Continuar"
                      : "Grabar"}
                  </button>
                )}
                <button
                  hidden={planificacion?.ID_ESTADO !== E_EstadoPlanificacion.ResultadosEvaluacionInformados}
                  type="button"
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    grabarMedidas(undefined, true);
                  }}>
                  {" "}
                  <i className="bi me-2"></i> Continuar
                </button>

                {(planificacion?.EVALUADOR_LIDER === currentUser?.email || isEvaluator(planificacion?.EVALUADORES, currentUser)) && (
                  <>
                    <button
                      hidden={
                        planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
                        planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
                        planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
                        planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvaluacionCerrada ||
                        (rejected && planificacion?.ID_ESTADO !== E_EstadoPlanificacion.AccionesAsignadas) ||
                        (rechazados && planificacion?.ID_ESTADO === E_EstadoPlanificacion.AccionesAsignadas)
                      }
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        aprobarMedidas(false);
                      }}>
                      {" "}
                      <i className="bi me-2"></i> Rechazar medidas
                    </button>
                    <button
                      hidden={
                        planificacion?.ID_ESTADO === E_EstadoPlanificacion.ResultadosEvaluacionInformados ||
                        planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas ||
                        planificacion?.ID_ESTADO === E_EstadoPlanificacion.EvidenciaEnviada ||
                        planificacion?.ID_ESTADO == E_EstadoPlanificacion.EvaluacionCerrada
                      }
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        aprobarMedidas(true);
                      }}>
                      {" "}
                      <i className="bi me-2"></i> Aprobar medidas
                    </button>

                    <button
                      hidden={planificacion?.ID_ESTADO !== E_EstadoPlanificacion.EvidenciaEnviada}
                      type="button"
                      className="btn btn-sm btn-primary me-2"
                      onClick={() => {
                        cerrarMedidas();
                      }}>
                      {" "}
                      <i className="bi me-2"></i> Cerrar medidas
                    </button>
                  </>
                )}
                <button
                  hidden={
                    planificacion?.ID_ESTADO !== E_EstadoPlanificacion.MedidasAprobadas ||
                    (planificacion?.ID_ESTADO === E_EstadoPlanificacion.MedidasAprobadas &&
                      planificacion.PROVEEDOR_RESPONSABLE !== currentUser?.email &&
                      !listItems.some((d) => d.RESPONSABLE === currentUser?.email))
                  }
                  type="button"
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    enviarMedidas();
                  }}>
                  {" "}
                  <i className="bi me-2"></i> Enviar medidas
                </button>
                <button
                  type="button"
                  className="btn btn-sm btn-primary me-2"
                  onClick={() => {
                    window.location.href = "/proveedores/home";
                  }}>
                  {" "}
                  <i className="bi me-2"></i> Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Medidas;
